var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "ui segments" },
        [
          _c("div", { staticClass: "ui segment" }, [
            _c("h3", { staticClass: "ui header" }, [
              _vm._v(_vm._s(_vm.$t("pages.bookings.available_bookings")))
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.bookings.data, function(booking) {
            return !_vm.fetchError
              ? _c("div", { key: booking.id, staticClass: "ui segment" }, [
                  _c(
                    "div",
                    { staticClass: "ui two column middle aligned grid" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sixteen wide mobile eight wide tablet eight wide computer left aligned column"
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(booking.product.name) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sixteen wide mobile eight wide tablet eight wide computer right aligned column"
                        },
                        [
                          booking.product.apply_storage_count &&
                          booking.product.storage_count < 1
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ui fluid red button disabled"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "modals.availableproducts.not_available"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ui fluid blue button",
                                    class:
                                      _vm.activeMerchant &&
                                      _vm.activeMerchant.opus &&
                                      !_vm.$auth.user().social_number
                                        ? "disabled"
                                        : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.openBookingModal(booking.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("globals.buttons.reserve"))
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    ]
                  )
                ])
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.fetchError
            ? _c("div", { staticClass: "ui segment" }, [
                _c("h1", [
                  _vm._v(
                    _vm._s(_vm.$t("globals.validation.errors.nothing_found"))
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("paginate", {
        attrs: {
          "page-count": _vm.bookings.last_page || 0,
          "page-range": 2,
          "margin-pages": 1,
          "click-handler": _vm.paginate,
          "prev-text": "Prev",
          "prev-class": "item",
          "next-text": "Next",
          "next-class": "item",
          "container-class": "ui menu pagination zw-paginate",
          "page-class": "item"
        }
      }),
      _vm._v(" "),
      _vm.selectedBookingId !== null
        ? _c("new-booking-modal", {
            attrs: {
              active: _vm.showBookingModal,
              bookingid: _vm.selectedBookingId,
              selectedPlace: _vm.selectedPlace
            },
            on: {
              onClose: function($event) {
                _vm.selectedBookingId = null
              },
              "open-image": _vm.handleOpenImage
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showWinterPlaceModal
        ? _c("winter-place-modal", {
            attrs: { "selected-map-element": _vm.selectedSpot },
            on: {
              close: function($event) {
                _vm.showWinterPlaceModal = false
              },
              "polygon-selected": _vm.handlePolygonSelected
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2834b13c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2834b13c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/booking/AvailableBookings.vue
// module id = dmWs
// module chunks = 1